import {
  POLLING_TIMEOUT,
  PAYMENT_POLLING_FREQUENCY,
  PAYMENT_GIFT_CARD_ORDER_PREPEND,
} from '@mindfulchefuk/constants'

import { getPaymentTransaction } from '@mindfulchefuk/services/getPaymentTransaction'

import {
  PollingState,
  usePollingStateMachine,
  UsePollingStateMachineProps,
  PollingArgs,
} from '@mindfulchefuk/hooks/usePollingStateMachine'

type GiftcardPaymentType = {
  pollingState: PollingState
  startPolling: (args: PollingArgs) => void
}

type Props = {
  giftCardId: string
  onSuccess: () => void
  onFailure: UsePollingStateMachineProps['onFailure']
}

type GiftCardPollingArgs = {
  id: string
}

export const useGiftCardPaymentPolling = ({
  onSuccess,
  onFailure,
}: Props): GiftcardPaymentType => {
  const getStatus = ({ id }: GiftCardPollingArgs) =>
    getPaymentTransaction({
      prefixId: PAYMENT_GIFT_CARD_ORDER_PREPEND,
      orderId: id,
    })

  const { pollingState, startPolling } = usePollingStateMachine({
    interval: PAYMENT_POLLING_FREQUENCY,
    timeout: POLLING_TIMEOUT,
    getStatus,
    onSuccess,
    onFailure,
    errorMessage: 'Gift card payment failed',
  })

  return {
    pollingState,
    startPolling,
  }
}
